const CommonFallback = () => {
  return <p>Fetching data...</p>
}

export default CommonFallback
